<template>
  <div class="card mb-3 pt-3">
         <div class="card-body">
            <Loading v-if="showLoading" />
            <form class="row" v-on:submit.prevent="editSubmit">
                <div class="col-12 mb-2">
                    <h5>اطلاعات {{organization.title  }}</h5>
                </div>
                <div class="col-md-3">
                    <div class="form-group">
                        <label> <label style="color: red; height: 2px;" >*</label>
                            نام </label>
                        <input required type="text" class="form-control" v-model="organization.title">
                    </div>
                </div>
                <div class="col-md-3">
                    <div class="form-group">
                        <label> <label style="color: red; height: 2px;" >*</label>
                            نام کاربری</label>
                        <input required type="tel" class="form-control ltr-input" v-model="organization.username">
                    </div>
                </div>
                 <div class="col-md-3" v-if="$store.state.role == 'admin'">
                    <div class="form-group">
                        <label>سوییچ صادرکننده بن کارت (کارت نقدی)</label>
                        <select class="form-control" v-model="organization.cardIssuerId">
                            <option v-for="(provider,index) in providers" :key="index" :value="provider.id">{{
                                provider.title }}</option>
                        </select>
                    </div>
                </div>
                 <div class="col-md-3" v-if="$store.state.role == 'admin'">
                        <div class="form-group">
                            <label>سوییچ صادرکننده کارت هدیه</label>
                            <select class="form-control" v-model="organization.giftCardIssuerId">
                                <option v-for="(provider,index) in providers" :key="index" :value="provider.id">{{
                                    provider.title }}</option>
                            </select>
                        </div>
                    </div>
                <div class="col-md-12 mt-2" v-if="$store.state.role == 'admin'">
                    <label class="custom-switch mb-3">
                        <input type="checkbox" name="custom-switch-checkbox" class="custom-switch-input"
                            v-model="organization.needDelivery">
                        <span class="custom-switch-indicator"></span>
                        <span class="custom-switch-description">ارسال توسط پست</span>
                    </label>
                </div>
                <div class="col-md-12" v-if="$store.state.role == 'admin'">
                    <label class="custom-switch mb-3">
                        <input type="checkbox" name="custom-switch-checkbox" class="custom-switch-input"
                            v-model="organization.tourism">
                        <span class="custom-switch-indicator"></span>
                        <span class="custom-switch-description">سازمان از نوع گردشگری می باشد</span>
                    </label>
                </div>
                <div class="col-md-12" v-if="$store.state.role == 'admin'">
                    <label class="custom-switch mb-3">
                        <input type="checkbox" name="custom-switch-checkbox3" class="custom-switch-input"
                            v-model="organization.fidaConsumerAllow">
                        <span class="custom-switch-indicator"></span>
                        <span class="custom-switch-description"> آیا برای این سازمان دسترسی کد فیدا (اتباع خارجی ) وجود
                            داشته باشد ؟ </span>
                    </label>
                </div>
                <hr class="w-100" />
                <div v-if="organization.domainMetaData" class="row" >
                    <div class="col-12 mb-2">
                        <h5>کاربر زیرمجموعه</h5>
                    </div>
                    <div class="col-md-3">
                        <div class="form-group">
                            <label>
                                 <label style="color: red; height: 2px;" >*</label>نام مسئول</label>
                            <input required type="text" class="form-control" v-model="organization.domainMetaData.firstName">
                        </div>
                    </div>
                    <div class="col-md-3">
                        <div class="form-group">
                            <label>
                                 <label style="color: red; height: 2px;" >*</label>نام خانوادگی مسئول</label>
                            <input required type="text" class="form-control" v-model="organization.domainMetaData.lastName">
                        </div>
                    </div>
                    <div class="col-md-3">
                        <div class="form-group">
                            <label><label style="color: red; height: 2px;" >*</label>
                                کد ملی مسئول</label>
                            <input required type="tel" class="form-control ltr-input" v-mask="'##########'" v-model="organization.domainMetaData.nationalCode">
                        </div>
                    </div>
                    <div class="col-md-3">
                        <div class="form-group">
                            <label><label style="color: red; height: 2px;" >*</label>
                                شماره همراه مسئول</label>
                            <input required type="tel" class="form-control ltr-input" v-mask="'####-#######'" v-model="organization.domainMetaData.mobile">
                        </div>
                    </div>
                    <div class="col-md-3">
                        <div class="form-group">
                            <label><label style="color: red; height: 2px;" >*</label>
                                ایمیل مسئول</label>
                            <input required type="email" class="form-control ltr-input" v-model="organization.domainMetaData.email">
                        </div>
                    </div>
                    <div class="col-md-3">
                        <div class="form-group">
                            <label><label style="color: red; height: 2px;" >*</label>
                                شماره تماس (همراه با کد شهر)</label>
                            <input required type="tel" class="form-control ltr-input" v-mask="'###-########'" v-model="organization.domainMetaData.phone">
                        </div>
                    </div>
                    <div class="col-md-6" v-if="organization.domainMetaData.iban && organization.domainMetaData.depositNumber">
                        <div class="form-group">
                            <label><label style="color: red; height: 2px;" >*</label>
                                شماره حساب</label>
                            <input required type="tel" class="form-control ltr-input" v-model="organization.domainMetaData.depositNumber">
                        </div>
                    </div>
                    <div class="col-md-6" v-if="organization.domainMetaData.iban && organization.domainMetaData.depositNumber">
                        <div class="form-group">
                            <label><label style="color: red; height: 2px;" >*</label>
                                شماره شبا</label>
                            <input required type="tel" class="form-control ltr-input" v-model="organization.domainMetaData.iban">
                        </div>
                    </div>
                    <div class="col-md-3">
                        <div class="form-group">
                            <label><label style="color: red; height: 2px;" >*</label>
                                نام فارسی سازمان</label>
                            <input required type="text" class="form-control" v-model="organization.domainMetaData.companyNameFa" >
                        </div>
                    </div>
                    <div class="col-md-3">
                        <div class="form-group">
                            <label>نام انگلیسی سازمان</label>
                            <input required  type="text" class="form-control ltr-input" v-model="organization.domainMetaData.companyNameEn" >
                        </div>
                    </div>
                    <div class="col-md-3">
                        <div class="form-group">
                            <label><label style="color: red; height: 2px;" >*</label>
                                شناسه ملی</label>
                            <input required type="tel" class="form-control ltr-input" v-mask="'###########'" v-model="organization.domainMetaData.nationalId">
                        </div>
                    </div>
                    <div class="col-md-3">
                        <div class="form-group">
                            <label><label style="color: red; height: 2px;" >*</label>
                                شماره ثبت</label>
                            <input required type="tel" class="form-control ltr-input" v-mask="'#######'" v-model="organization.domainMetaData.registryno">
                        </div>
                    </div>
                
                    <div class="col-md-12 my-3">
                        <button class="btn btn-primary">{{ this.$route.params.id ? "به روز رسانی سازمان" : "ایجاد سازمان"  }}</button>
                        <button v-if="this.$route.params.id" class="btn btn-secondary mr-3" @click="resetPassword">
                            <i class="ti-key ml-1 rotate-90"></i>
                            بازیابی گذرواژه 
                        </button>
                    </div>
                </div>
            </form>
            <div class="row" v-if="this.$route.params.id">
                <hr class="w-100 pt-2">
                <div class="col-md-12">
                    <form class="row" v-on:submit.prevent="submit">
                        <div class="col-md-3">
                            <label>انتخاب فایل قرارداد</label>
                            <div class="input-group file-browser">
                                <input required type="text" class="form-control border-left-0 browse-file" id="contract-file" placeholder="آپلود فایل" readonly="">
                                <label class="input-group-btn mb-0">
                                    <span class="btn btn-primary">
                                        انتخاب کنید <input type="file" style="display: none;" accept=".pdf" @input="setPdfFile">
                                    </span>
                                </label>
                            </div>
                        </div>
                        <div class="col-md-3">
                            <label>تاریخ شروع قرارداد</label>
                            <Datepicker simple auto-submit id="start-date" locale="fa" v-model="fromDate" format="YYYY-MM-DD" :locale-config="{
                                fa: {
                                    displayFormat: 'jYYYY/jMM/jDD',
                                    lang: {label: 'شمسی'}
                                }
                            }" />
                        </div>
                        <div class="col-md-3">
                            <label>تاریخ اتمام قرارداد</label>
                            <Datepicker simple auto-submit id="end-date" locale="fa" v-model="toDate" format="YYYY-MM-DD" :locale-config="{
                                fa: {
                                    displayFormat: 'jYYYY/jMM/jDD',
                                    lang: {label: 'شمسی'}
                                }
                            }" />
                        </div>
                        <div class="col-md-12 mt-4">
                            <button :disabled="!file" class="btn btn-primary" >ثبت قرارداد جدید</button>
                        </div>
                    </form>
                    
                </div>
            </div>
            <div class="row" v-if="contracts.length && this.$route.params.id">
                <hr class="w-100" >
                <div class="col-md-12 my-2" >
                    <h5>لیست قرارداد ها</h5>
                </div>
                <div class="col-xl-3 col-md-5 col-sm-12 mx-1" v-for="(contract,index) in contracts" :key="index">
                    <div class="card custom-card card-body contract-item border-1 bg-primary-gradient text-white">
                        <div class="row">
                            <div class="col-md-11 mb-4">
                                <p class="mb-0">قرارداد از تاریخ <span dir="ltr">{{ contract.persianStartDate.replace(/\-/g,'/') }}</span> تا <span dir="ltr">{{ contract.persianExpireDate.replace(/\-/g,'/') }}</span></p>
                            </div>
                        </div>
                        <div class="row">
                            <button class="btn  btn-block btn-primary" :disabled="!contract.contractPdf" @click="downloadContract(index)">دانلود قرارداد</button>
                        </div>
                    </div>
                </div>
        
            </div>
        </div>

   </div>
   
</template>

<script>
export default {
    name: 'CreateOrUpdate',
    data(){
        return {
            showLoading: true,
            contracts: [],
            fromDate: '',
            toDate: '',
            file: '',
            organization:{
                title: "",
                cardIssuerId: "",
                giftCardIssuerId: "",
                tourism :false,
                fidaConsumerAllow:false,
                needDelivery: 0,
                username: "",
                domainMetaData: {
                    firstName: "",
                    lastName: "",
                    phone: "",
                    nationalCode: "",
                    mobile: "",
                    email: "",
                    nationalId: "",
                    companyNameEn: "",
                    companyNameFa: "",
                    registryno: ""
                },
            },
            providers:[]
        }
    },
    methods: {
        async getData(){
            this.$api.get('Organizations/Issuers').then(({ data }) => {
                if (data.status)
                    this.providers = data.result;
            })
            if(this.$route.params.id){
                this.$api.post('Management/organizations/List',{organizationId: this.$route.params.id}).then(({data}) => {
                    if(data.status){
                        const organization = data.result.list[0];
                        this.organization.title= organization.title,
                        this.organization.cardIssuerId= organization.cardIssuerId,
                        this.organization.giftCardIssuerId= organization.giftCardIssuerId,
                        this.organization.tourism =organization.tourism,
                        this.organization.fidaConsumerAllow=organization.fidaConsumerAllow,
                        this.organization.needDelivery= organization.needDelivery,
                        this.organization.username= organization.username,
                        this.organization.domainMetaData= {
                            firstName:organization.domainMetaData.firstName,
                            lastName: organization.domainMetaData.lastName,
                            phone:organization.domainMetaData.phone ,
                            nationalCode: organization.domainMetaData.nationalCode,
                            mobile: organization.domainMetaData.mobile,
                            email: organization.domainMetaData.email,
                            nationalId: organization.domainMetaData.nationalId,
                            companyNameEn: organization.domainMetaData.companyNameEn,
                            companyNameFa: organization.domainMetaData.companyNameFa,
                            registryno: organization.domainMetaData.registryno
                        }
                    }
                }).finally(() => {
                    this.showLoading = false;
                });
            }
        },
        async resetPassword(e){
            e.preventDefault();
            this.showLoading = true;
            const postedData = {
                domainDataId: this.$route.params.id,
            };
            this.$api.post('user/ResetPassword',postedData).then(({data}) => {
                if(data.status){
                    this.$swal({
                        icon: 'success',
                        title: 'تبریک !',
                        text: 'گذرواژه ی جدید با موفقیت ارسال شد.',
                    }).then(res => {
                        this.showLoading = false;
                    });
                }
            }).catch(() => {
                this.$swal({
                    title: 'ناموفق',
                    icon: 'error',
                    text: 'ارسال گذرواژه ی جدید با خطا مواجه شد. لذا مجددا اقدام نمایید.'
                }).then(() => {
                    this.showLoading = false;
                });
            }).finally(() => {
                this.showLoading = false;
            })
        },
        async setPdfFile(e){
            const file = e.target.files[0];
            if(file.size > 1000000){
                this.$swal({
                    title: 'خطا',
                    icon: 'error',
                    text: 'حجم فایل قرارداد نمی تواند بیشتر از 1 مگابایت باشد'
                });
                document.getElementById('contract-file').setAttribute('placeholder','انتخاب کنید');
                this.file = '';
            }else{
                const finalFile = await this.toBase64(file);
                this.file = finalFile;
                document.getElementById('contract-file').setAttribute('placeholder',file.name);
            }
        },
        async toBase64(file){
            return new Promise((resolve, reject) => {
                const reader = new FileReader();
                reader.readAsDataURL(file);
                reader.onload = () => resolve(reader.result);
                reader.onerror = error => reject(error);
            });
        },
        downloadContract(index){
            if(this.contracts.length > 0){
                const contract = this.contracts[index];
                let a = window.document.createElement('a');
                a.setAttribute('href',contract.contractPdf);
                a.setAttribute('download',"file.pdf");
                window.document.body.appendChild(a);
                a.click();
                window.document.body.removeChild(a);
        }
        },
        async getContracts(){
            this.showLoading = true;
            this.$api.get('Organizations/Bonus/Contracts?OrganizationId=' + this.$route.params.id).then(({data}) => {
                this.contracts = data.result;
            }).finally(() => {
                this.showLoading = false;
            });
        },
        async submit(){
            this.showLoading = true;
            const postedData = {
                organizationId: this.$route.params.id,
                persianStartDate: this.fromDate,
                persianExpireDate: this.toDate,
                pdf: this.file
            };
            this.$api.post('Organizations/Bonus/Contracts',postedData).then(({data}) => {
                if(data.status){
                    this.$swal({
                        icon: 'success',
                        title: 'تبریک !',
                        text: 'ثبت قرارداد با موفقیت انجام شد',
                    }).then(res => {
                        this.showLoading = false;
                        if(res.isConfirmed){
                           this.getContracts()
                        }
                    });
                }
            }).catch(() => {
                this.$swal({
                    title: 'ناموفق',
                    icon: 'error',
                    text: ' اطلاعات ثبت نشد ,لذا مجدد اقدام کنید!'
                }).then(() => {
                    this.showLoading = false;
                });
            }).finally(() => {
                this.showLoading = false;
            })
        },
        async editSubmit(){
            this.showLoading = true;
            let postedData = this.organization;
            if(this.$route.params.id ){
                postedData = {...postedData,  customerId: this.$route.params.id,}
            }
            this.$api.defaults.baseURL = "https://cardapi.sabinarya.com/api/v2/",
            this.$api.post( this.$route.params.id  ? 'management/EditLegalCustomer' :'management/RegisterLegalCustomer',postedData ).then(({data}) => {
                if(data.status){
                    this.$swal({
                        title: 'تبریک',
                        icon: 'success',
                        text: this.$route.params.id  ? 'سازمان با موفقیت به روزرسانی شد' :'سازمان با موفقیت ایجاد شد'
                    }).then(() => {
                        this.$router.push({name: 'organizations.update' ,params: {id: data.result.id}});
                    });
                }
            }).finally(() => {
                 this.$api.defaults.baseURL = "https://cardapi.sabinarya.com/api/v1",
                this.showLoading = false;
            });
        }
    },
    async created(){
        this.getData();
        this.getContracts()
    }
}
</script>